import {Component, HostBinding, OnInit} from '@angular/core';
import { ShelfModel, StoreUpdateCommand} from 'app/domain/shops-wrapper/shops/model/models';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StoresDataService} from 'app/domain/shops-wrapper/shops/services/stores.data.service';
import {GeneralService, SnackbarService} from 'app/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Observable} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'pr-shelf-create',
  templateUrl: './shelf-create.component.html',
  styleUrls: ['./shelf-create.component.scss']
})
export class ShelfCreateComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow action-button-padding';

    shelf: ShelfModel = {} as ShelfModel;
    creatingForm: FormGroup;
    isSaving = false;
    id: number = null;

    navigationBackArray = ['metadata', 'settings', 'shelves'];

    constructor(
        public dataService: StoresDataService,
        public snackBar: SnackbarService,
        private route: ActivatedRoute,
        private _location: Location,
        public generalService: GeneralService,
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit() {
        this.id = +this.route.snapshot.paramMap.get('id');

        this.creatingForm = this.formBuilder.group({
            Name: ['', Validators.required],
            Meters: ['', Validators.min(0.0001)],
        });

        if (this.id) {
            this.fillForm();
        }
    }


    private fillForm() {
        this.dataService.getShelf(this.id)
            .subscribe(shelf => {
                    this.creatingForm.patchValue(shelf);
                },
                (err) => {
                    if (err.status !== 403) {
                        this.snackBar.info('Wystąpił błąd podczas zapytania');
                    }
                }
            );
    }

    public checkIfCreatePage(): boolean {
        return !this.id;
    }

    public onSubmit() {
        if (!this.creatingForm.valid) {
            this.snackBar.info('Wszystkie pola muszą być wypełnione.');
            return;
        }
        let form;
        let createObs: Observable<any>;
        if (this.id) {
            form = this.formUpdateData();
            createObs = this.dataService.updateShelf(form);
        } else {
            form = this.creatingForm.value;
            createObs = this.dataService.createShelf(form);
        }
        this.isSaving = true;
        createObs
            .subscribe(
                res => console.log(res),
                err => this.shopError(err),
                () => this.shopCreated()
            );
    }

    private formUpdateData(): StoreUpdateCommand {
        return {...this.creatingForm.value, Id: this.id};
    }

    private shopCreated(): void {
        this.isSaving = false;
        const shopCreateText = this.checkIfCreatePage() ? 'Regał został utworzony.' : 'Zmiany zostały zapisane.';
        this.snackBar.info(shopCreateText);
        this._location.back();
    }

    private shopError(err: HttpErrorResponse) {
        this.isSaving = false;
        if (err.status !== 403) {
            this.snackBar.info('Podczas zapisywania wystąpił błąd.');
        }
    }

    public navigationBack(): void {
        this.generalService.navigateTo(this.navigationBackArray);
    }
}
